import { TRACE_STORE_NAME } from '@/creditflowresearch/application/Trace/constants';
import TwoLevelList from '@/creditflowresearch/ui/common/components/organisms/Filters/FiltersPanel/TwoLevelList/TwoLevelList';
import { useFiltersContext } from '@framework/ui/Organisms/Filters/FiltersContext';
import { useCheckboxerContext } from '@framework/ui/Organisms/Filters/Checkboxer/CheckboxerContext';

const TwoLevelListContainer = (props) => {
  const { filterName } = props;
  const { getFiltersByFilterName } = useFiltersContext();
  const { checkboxes, getCheckboxChildren } = useCheckboxerContext();

  const filters = getFiltersByFilterName(TRACE_STORE_NAME, filterName);

  return (
    <TwoLevelList
      { ...props }
      checkboxes={ checkboxes }
      filterName={ filterName }
      filters={ filters }
      getCheckboxChildren={ getCheckboxChildren }
    />
  );
};

export default TwoLevelListContainer;
